import { render, staticRenderFns } from "./CmgCelebratePoints.vue?vue&type=template&id=3fd3d8c1&scoped=true&lang=pug"
import script from "./cmg-celebrate-points.ts?vue&type=script&lang=ts&external"
export * from "./cmg-celebrate-points.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCelebratePoints.vue?vue&type=style&index=0&id=3fd3d8c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd3d8c1",
  null
  
)

export default component.exports